<template>
  <div class="">
    <label for="text_answer" class="block mb-2 text-sm font-medium text-gray-900"
    >{{ __('question.your_answer') }}</label>
    <textarea id="text_answer" class="card text-sm md:text-base" rows="8" :placeholder="__('question.your_answer')" @input="debounceAnswer"></textarea>
      <span v-if="isTyping" class="block text-sm">{{ __('question.you_are_typing') }}</span>
  </div>
</template>

<script>
export default {
  name: 'TextQuestion',
  emits: ['update'],

  data() {
    return {
      isTyping: false,
      debounce: null,
      answer: null,
      timeout: 300,
    }
  },

  methods: {
    debounceAnswer(event) {
      this.message = null
      this.isTyping = true
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.isTyping = null
        this.answer = event.target.value

        this.$emit('update', this.answer)
      }, this.timeout)
    },
  },
}
</script>

<style scoped>
 #text_answer {
   width: 100%;
   max-width: 100%;
 }
</style>